import { ZodTypeAny, any } from 'zod'

export type TSNoop<T> = ZodTypeAny & {
  readonly __brand_noop: 'accepts-anything'
  readonly __type?: T
}

/**
 * accepts anything, but still gives a type to the parsed value
 * useful for refactorings and migrations from non-parsed types to safe ones
 */
export const SNoop = <T>(): TSNoop<T> => {
  return any() as unknown as TSNoop<T>
}
